<template>
  <BaseList
    document-type="custom_fields"
    :show-modal-button="false"
    list-type="toggle"
    meta-name="Custom Fields"
    api-items-field="customFields"
    path="/app/settings/organization-settings/custom-fields"
    :list-field-names="{ main: '', status: 'Use for filtering', toggleModel: 'isSearch' }"
    :toggle-actions="{ active: 'on', inactive: 'off' }"
    :api-names="{
      load: 'settingsGetCustomFields',
      post: 'settingsUpdateCustomFields',
    }"
  />
</template>

<script>
import BaseList from './components/lists/BaseList.vue';

export default {
  name: 'CustomFields',
  components: {
    BaseList,
  },
};
</script>
